/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyLabelFeatureDto } from '../../models/survey-label-feature-dto';

export interface IdentifySurveyLabel$Params {
  id: string;
}

export function identifySurveyLabel(
  http: HttpClient,
  rootUrl: string,
  params: IdentifySurveyLabel$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyLabelFeatureDto>> {
  const rb = new RequestBuilder(rootUrl, identifySurveyLabel.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyLabelFeatureDto>;
      }),
    );
}

identifySurveyLabel.PATH = '/identify/survey-label';
